module.exports = __webpack_public_path__ + "static/media/vba.73ac2e2b.webp";